import { Txt } from 'components/Txt';
import { theme } from 'lib/theme';
import * as React from 'react';
import { StyleProp, StyleSheet, TextStyle, View } from 'react-native';
import { Icon, ICONS } from './Icon';
import { ViewWithSeparators } from './ViewWithSeparators';

type Props = {
  title: string;
  titleStyle?: StyleProp<TextStyle>;
  subtitle?: string | React.ReactNode;
  subsubtitle?: string | React.ReactNode;
  titleColor?: string;
  subtitleColor?: string;
  subsubtitleColor?: string;
  screenSize?: 'small' | 'large';
  subtitleIcons?: ICONS[];
  titleStyledAsCardLabel?: boolean;
  small?: boolean;
};

export const ItemDetails: React.FC<Props> = ({
  screenSize = 'large',
  title,
  titleStyle,
  subtitle,
  subsubtitle,
  titleColor,
  subtitleColor,
  subsubtitleColor,
  subtitleIcons,
  titleStyledAsCardLabel,
  small,
}) => (
  <View style={screenSize === 'small' ? styles.detailsSmall : styles.details}>
    {!!title && (
      <Txt
        weight={titleStyledAsCardLabel ? undefined : 'medium'}
        size={titleStyledAsCardLabel ? undefined : small ? 'normal' : 'large'}
        style={[titleStyle, titleColor ? { color: titleColor } : undefined]}
        numberOfLines={1}
      >
        {title}
      </Txt>
    )}
    {(!!subtitle || !!subtitleIcons?.length) && (
      <ViewWithSeparators
        horizontal
        style={{ alignItems: 'center', alignSelf: 'stretch' }}
        separatorMargin={theme.padding / 4}
        separatorColor="tranparent"
      >
        {!!subtitle && (
          <Txt
            size="xsmall"
            style={[
              styles.textSubtitle,
              subtitleColor ? { color: subtitleColor } : undefined,
            ]}
            numberOfLines={1}
          >
            {subtitle}
          </Txt>
        )}
        {subtitleIcons?.map((subtitleIcon, index) => (
          <Icon source={subtitleIcon} key={index} size={12} />
        ))}
      </ViewWithSeparators>
    )}
    {!!subsubtitle && (
      <Txt
        size="xsmall"
        style={[
          styles.textSubsubtitle,
          subsubtitleColor ? { color: subsubtitleColor } : undefined,
        ]}
        numberOfLines={1}
      >
        {subsubtitle}
      </Txt>
    )}
  </View>
);

const styles = StyleSheet.create({
  details: {
    alignItems: 'flex-start',
    flex: 1,
    flexDirection: 'column',
  },
  detailsSmall: {
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  textSubtitle: {
    color: theme.colors.fieldValueText,
  },
  textSubsubtitle: {
    color: theme.colors.fieldValueText,
  },
});
